import { create } from 'zustand';
import { AlertSrv, FormValidator, setValue } from '../helpers';

export const FormBaseController = (options: any) => {
    let { _id, formConfig, defaultFormModel = {}, lookupKeys = null, validationMap = {}, cascadingMap = {}, actions, customActions } = options;
    let formModel = JSON.parse(JSON.stringify(defaultFormModel));
    defaultFormModel = JSON.parse(JSON.stringify(defaultFormModel));

    const addItem = (set: any, get: any) => {
        return async (callback: any) => {
            let currentModel = get().formModel;
            let validationMap = get().validationMap;

            //Validation code starts
            const validationResult = FormValidator.bulkValidate(
                validationMap,
                currentModel
            );
            set({ errors: validationResult.errors });
            if (!validationResult.isValid) return;

            let result = await actions.add(currentModel);
            AlertSrv.showMessage(result);

            //callback to perform any postProcess action
            callback(result);
        }
    }

    const updateItem = (set: any, get: any) => {
        return async (callback: any) => {
            let currentModel = get().formModel;
            let validationMap = get().validationMap;

            //Validation code starts
            const validationResult = FormValidator.bulkValidate(
                validationMap,
                currentModel
            );
            set({ errors: validationResult.errors });
            if (!validationResult.isValid) return;

            let result = await actions.update(currentModel);
            AlertSrv.showMessage(result);

            //callback to perform any postProcess action
            callback(result);
        }
    }

    const getItemById = (set: any, get: any) => {
        return async (currentId: any) => {
            set({ _id: currentId });
            if (currentId) {
                let inputData: any = {
                    _id: currentId
                };
                let result = await actions.getItemById(inputData);
                set({ formModel: result, errors: {} });
            }
        }
    }

    const getLookups = (set: any, get: any) => {
        return async () => {
            let lookupKeyList = get().lookupKeys;
            if (lookupKeyList && actions.getLookups) {
                const inputData: any = {
                    "lookups": lookupKeyList
                };
                let result = await actions.getLookups(inputData);
                set({ lookup: result });
            }
        }
    }

    const handleInputChange = (set: any, get: any) => {
        return (item: any) => {
            if (item.path) {
                let currentModel = get().formModel;
                let data = setValue(currentModel, item.path, item.value);
                let inputData = { ...currentModel, ...data };
                set({ formModel: inputData });
            } else {
                let data = { [item.name]: item.value };
                let currentModel = get().formModel;
                let inputData = { ...currentModel, ...data };
                set({ formModel: inputData });
            }
        }
    }

    const handleArrayInputChange = (set: any, get: any) => {
        return (item: any, arrayProp: any, rowIdx: any) => {
            if (item.path) {
                let currentModel = get().formModel;
                let arrayData = currentModel[arrayProp];
                let rowData = arrayData[rowIdx];
                let rowDataUpdated = setValue(rowData, item.path, item.value);
                let inputData = { ...currentModel, ...{ [arrayProp]: arrayData } };
                set({ formModel: inputData });
            } else {
                let currentModel = get().formModel;
                let arrayData = currentModel[arrayProp];
                let rowData = arrayData[rowIdx];
                let rowDataUpdated = setValue(rowData, item.name, item.value);
                let inputData = { ...currentModel, ...{ [arrayProp]: arrayData } };
                set({ formModel: inputData });
            }
        }
    }

    const addItemToArray = (set: any, get: any) => {
        return (item: any, arrayProp: any) => {
            let currentModel = get().formModel;
            let arrayData = currentModel[arrayProp];
            let newItem = JSON.parse(JSON.stringify(item));
            arrayData.push(newItem);
            let inputData = { ...currentModel, ...{ [arrayProp]: arrayData } };
            set({ formModel: inputData });
        }
    }

    const deleteItemFromArray = (set: any, get: any) => {
        return (item: any, arrayProp: any, itemIndex: any) => {
            let currentModel = get().formModel;
            let arrayData = currentModel[arrayProp];
            arrayData.splice(itemIndex, 1);
            let inputData = { ...currentModel, ...{ [arrayProp]: arrayData } };
            set({ formModel: inputData });
        }
    }

    const handleFormModelChange = (set: any, get: any) => {
        return (data: any) => {
            let currentModel = get().formModel;
            let inputData = { ...currentModel, ...data };
            set({ formModel: inputData });
        }
    }

    const setFormOptions = (set: any, get: any) => {
        return (data: any) => {
            let formModel = data.formModel || {};
            let validationMap = data.validationMap || {};
            let lookupKeys = data.lookupKeys || {};
            let cascadingMap = data.cascadingMap || {};
            let defaultModel = JSON.parse(JSON.stringify(formModel));
            set({
                defaultFormModel: defaultModel, formModel: formModel,
                validationMap: validationMap, lookupKeys: lookupKeys, cascadingMap: cascadingMap
            });
        }
    }

    const loadAllCacadingLookups = (set: any, get: any) => {
        return async () => {
            let cascadingMap = get().cascadingMap;
            let formModel = get().formModel;
            let processCascadingLookups = get().processCascadingLookups;
            for (let key in cascadingMap) {
                if (formModel[key]) {
                    await processCascadingLookups(key);
                }
            }
        }
    }

    const processCascadingLookups = (set: any, get: any) => {
        return async (changedModelProp: any) => {
            let cascadingMap = get().cascadingMap;
            if (cascadingMap[changedModelProp]) {
                var lookupConfig: any = {};
                var filters: any = {};
                let formModel = get().formModel;
                let currentLookup = get().lookup;

                var result = cascadingMap[changedModelProp];
                for (let modelProp in result) {
                    var modelObj = result[modelProp];
                    lookupConfig[modelObj.lookupKey] = { default: true };
                    filters[changedModelProp] = formModel[changedModelProp];
                }
                let latestLookup = await getSpecificLookups(lookupConfig, filters, currentLookup);
                set({ lookup: latestLookup });
            }
        }
    }

    const getSpecificLookups = async (lookupConfig: any, filters: any, currentLookup: any) => {
        //if (!this.utl.isEmptyJSONObject(lookupConfig)) {
        var inputData = {
            lookups: lookupConfig,
            filters: filters
        };
        let result = await actions.getLookups(inputData);
        currentLookup = JSON.parse(JSON.stringify(currentLookup));
        for (let key in result) {
            currentLookup[key] = result[key];
        }
        return currentLookup;
        //}
    }

    const resetFormModel = (set: any, get: any) => {
        return async (callback: any) => {
            //Setting defaultModel
            let model = get().defaultFormModel;
            model = JSON.parse(JSON.stringify(model));
            set({ formModel: model, errors: {} });
        }
    }

    const prepareCustomActions = (set: any, get: any) => {
        let result: any = {};
        for (let key in customActions) {
            result[key] = customActions[key](set, get)
        }
        return result;
    }

    const getStore = () => {
        return create<any>((set: any, get: any) => ({
            defaultFormModel: defaultFormModel,
            formConfig: formConfig,
            formModel: formModel,
            _id: "",
            lookupKeys: lookupKeys,
            lookup: {},
            validationMap: validationMap,
            errors: {},
            cascadingMap: cascadingMap,
            getItemById: getItemById(set, get),
            getLookups: getLookups(set, get),
            addItem: addItem(set, get),
            updateItem: updateItem(set, get),
            handleInputChange: handleInputChange(set, get),
            handleArrayInputChange: handleArrayInputChange(set, get),
            handleFormModelChange: handleFormModelChange(set, get),
            setFormOptions: setFormOptions(set, get),
            addItemToArray: addItemToArray(set, get),
            deleteItemFromArray: deleteItemFromArray(set, get),
            resetFormModel: resetFormModel(set, get),
            processCascadingLookups: processCascadingLookups(set, get),
            loadAllCacadingLookups: loadAllCacadingLookups(set, get),
            ...prepareCustomActions(set, get)
        }));
    }


    return { addItem, updateItem, getItemById, getLookups, handleInputChange, handleFormModelChange, setFormOptions, getStore };
}